<template lang="pug">
div
  //- 页面骨架
  PageSkeleton(v-if="isPreRender")
  //- 页面内容
  .fuli-container(v-if="isLogin && !isPreRender")
    //- 页面导航
    WelfareNavbar(:points="points" @pointsClick="goBountyRecord")

    //- 页面头部
    WelfareHeader(
      :points="points"
      :bounty="bounty"
      :exchangeGoodsList="exchangeGoodsList"
      :rewardGuidingRules="rewardGuidingRules"
      :rewardCount="rewardCount"
      :isDueSoon="isDueSoon"
      :goodsCateInfo="goodsCateInfo"
      :bountyLoaded="bountyLoaded"
      :styleVersion="styleVersion"
      :noticeData="noticeData"
      @pointsClick="goBountyRecord"
      @bounty="refreshBounty"
      @awardClick="collectBonus"
    )

    //- 页面模块
    .page-modules
      .modules-new-header(:class="{ 'pure-version': isPureVersion }")
      template(v-for="m in modules")
        component.fuli-module(
          :is="FULI_MODULE_COMPONENT[m]",
          :moduleKey="m"
          :points="points"
          :bounty="bounty",
          :id="m"
          :class="[m, { 'exchange-style': m === 'welfare_bountyExchange' }]"
          :tabs="tabs"
          :popupKey="popupWindowKey"
          :rakeBackModuleInfo="rakeBackModuleInfo"
          :rewardGuidingRules="rewardGuidingRules"
          @bounty="refreshBounty",
          @coupon="() => {}",
        )(ref="module")

    //- 首屏弹窗
    template(v-if="popupWindow.key && POPUP_WINDOW_COMPONENT[popupWindow.key]")
      component(
        :is="POPUP_WINDOW_COMPONENT[popupWindow.key]"
        :visible="popupWindow.show"
        :info="popupWindow.data"
        @close="handlePopupWindowClose"
        @refresh="getPopupWindow"
      )
    //- 复访引导弹窗
    template(v-if="needRevisitGuide")
      RevisitGuidePopup(
        :visible="revisitGuideVisible"
        @close="handleRevisitGuideClose"
      )
    //- 金币领取动画&声音
    .collect-points-animate
      audio(id="audio" src="https://m.hellobike.com/resource/gallery/833/1_DdlUufFu.wav")
      Lottie.collect-points-lottie(
        url="https://m.hellobike.com/resource/gallery/833/rCppTVu3_3d.json"
        :autoplay="false"
        :loop="false"
        ref="lottieComponent"
      )

  //- 未登录页面
  LoginPage(v-if="!isLogin && !isPreRender")
</template>

<script>
import { Native, env } from '@hb/NBridge/lib/h5';
import eventBus from '@/const/eventBus.js';
import {
  safeJsonStringify,
  jumpUrl,
  preloadImages,
  compareVersions,
} from '@/utils/tools';
import { setStorageExpiresHour } from '@/utils/cache';
import { getVersion } from '@/utils/systemCode';
import { getPreFetchData } from '@/utils/getPreFetchData';
import { getBountyBasicInfo } from '@/api/bounty';
import {
  getReceiveRewardCount,
  collectReward,
  getPopupWindow,
} from '@/api/fuli';
// components
import Toast from '@/components/toast';
import config from '@/const/config';

import {
  getTokenAndKey,
  tryCatch,
  isPreRender,
  getTokenAndLocation,
} from '../../utils';
import {
  getExchangeGoodsList,
  getRewardGuideRules,
  judgeRevisitGuideVisible,
  getRakeBackBanner,
  rakeBackBannerAdapter,
  uploadEvent,
  getPageModuleList,
} from './common/helper';
import SPM from './common/spm';
// components
import CheckIn from './components/checkin';
import WelfareHeader from './new-version-cpns/welfare-header';
import PageSkeleton from './skeleton-cpns/page-skeleton';
import SignInCard from './new-version-cpns/sign-in-card';
import VideoRedPacket from './new-version-cpns/video-red-packet';
import RakeBack from './new-version-cpns/rake-back';
import WelfareNavbar from './new-version-cpns/welfare-navbar';
import BountySurprise from './components/bounty-surprise';

import {
  FULI_MODULE,
  FULI_MODULE_COMPONENT,
  TABS,
  POPUP_WINDOW_KEY,
  COUPON_STATUS,
  LOCAL_MODULES,
  WELFARE_VERSION,
  RAKE_BACK_AB,
  BONUS_WITHDRAWAL_SCENE,
  TOP_HEADER_BG_IMGS,
  DEFERRED_MODULES,
  POPUP_WINDOW_COMPONENT,
} from './consts';

export default {
  components: {
    CheckIn,
    WelfareHeader,
    PageSkeleton,
    SignInCard,
    VideoRedPacket,
    RakeBack,
    WelfareNavbar,
    BountySurprise,
    // 异步加载组件
    RevisitGuidePopup: () => import(
      /* webpackChunkName: "popup-window-module" */
      './new-version-cpns/revisit-guide-popup.vue'
    ),
    Lottie: () => import('@/components/lottie'),
    LoginPage: () => import('./new-version-cpns/login-page'),
  },
  data() {
    return {
      // 模块组件枚举
      FULI_MODULE_COMPONENT,
      // 首屏弹窗组件枚举
      POPUP_WINDOW_COMPONENT,
      // 模块列表
      modules: [],
      // 奖励金可兑金额
      bounty: 0,
      // 奖励金数量
      points: 0,
      // 兑换商品tab列表
      tabs: TABS,
      // 用户是否登录
      isLogin: true,
      // 用户token
      token: '',
      // 是否新版页面
      newTaskScene: true,
      // 单单返币奖励金数量
      rewardCount: 0,
      // 单单返奖励金是否即将过期
      isDueSoon: false,
      // 首屏弹窗key
      popupWindowKey: '',
      // 首屏弹窗数据
      popupWindowData: {},
      // 首屏弹窗信息
      popupWindow: {
        key: '',
        show: false,
        data: {},
      },
      // 提现入口场景
      BONUS_WITHDRAWAL_SCENE,
      // 页面AB版本控制
      taskScene: WELFARE_VERSION.NEW_TASK_SCENE_V2,
      // 是否展示复访弹窗
      revisitGuideVisible: false,
      // 页面状态(LOADING | SUCCESS)
      pageStatus: 'LOADING',
      // 奖励金引导规则信息配置
      rewardGuidingRules: [],
      // 新人兑换商品列表
      exchangeGoodsList: [],
      // 用户类型
      userType: '',
      // 新人引导兑换商品类目信息
      goodsCateInfo: {},
      // 电商返佣实验版本
      rakeSceneAb: RAKE_BACK_AB.NEW_V2,
      // 提现入口实验
      bonusWithdrawalScene: BONUS_WITHDRAWAL_SCENE.HIDE,
      // 电商返佣模块信息
      rakeBackModuleInfo: {},
      // 场景名称
      rewardSceneNameEns: ['platform_points'],
      // 是否需要展示复访弹窗
      needRevisitGuide: false,
      // 是否是第一次加载
      isFirstLoad: true,
      // 是否是第一次页面曝光
      firstPageView: true,
      // 是否是预渲染环境
      isPreRender: isPreRender(),
      // 奖励金加载状态
      bountyLoaded: false,
      // 数据预取状态管理
      preFetchStatus: {
        rakeBackBanner: false,
        pageModule: false,
      },
      // 页面模块列表
      moduleList: [],
      // 公告数据
      noticeData: {},
      // 样式版本
      styleVersion: '',
      // 缓存溢出状态
      cacheOverflow: false,
      // 已处理模块key列表
      processedModuleKeys: [],
      // 是否是纯净版页面
      isPureVersion: false,
    };
  },
  provide() {
    return {
      newTaskScene: () => this.newTaskScene,
      taskScene: () => this.taskScene,
      rakeSceneAb: () => this.rakeSceneAb,
      bonusWithdrawalScene: () => this.bonusWithdrawalScene,
      pageStatus: () => this.pageStatus,
      popupWindowInfo: () => ({
        key: this.popupWindowKey,
        data: this.popupWindowData,
      }),
      isPureVersion: () => this.isPureVersion,
      isWelfareApp: true,
    };
  },
  async created() {
    // 预渲染
    if (isPreRender()) {
      document.dispatchEvent(new Event('render-event'));
      return;
    }

    // 登录状态初始化
    const { isLogin } = await this.initUser();
    if (!isLogin) return;

    // 获取页面实验信息
    await this.getRewardCountAndAb();
    // 核心模块缓存预渲染
    if (!this.isPureVersion) {
      this.modules = LOCAL_MODULES;
      this.preRender();
    }
    // 初始化页面数据
    this.initPageData();
    // 页面事件上传
    uploadEvent();
    // 监听页面可见性变化
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
  },
  async mounted() {
    // 预渲染
    if (isPreRender()) {
      document.dispatchEvent(new Event('render-event'));
      return;
    }
    // 金币领取动画全局注册
    eventBus.$on('playCollectAnimate', () => {
      this.playCollectAnimate();
    });
  },
  destroyed() {
    // 移除页面回退监听
    if (this.needRevisitGuide) {
      window.removeEventListener('popstate', this.showRevisitGuide, false);
    }
    // 移除页面可见性变化监听
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    // 移除金币领取动画监听
    eventBus.$off('playCollectAnimate');
    // 页面退出埋点
    SPM.pageViewOut({
      businessInfo: {
        abtest: this.isPureVersion
          ? WELFARE_VERSION.OLD_TASK_SCENE
          : this.taskScene,
        port: '0',
      },
    });
  },
  methods: {
    // 核心模块预渲染
    async preRender() {
      try {
        // 获取新人兑换商品列表缓存
        // const guideCommodityInfo = getStorage(FULI_MODULE.welfare_guide_commodity);
        // if (guideCommodityInfo) {
        //   this.goodsCateInfo = {
        //     ...guideCommodityInfo.goodsCateInfo,
        //     isCache: true,
        //   };
        //   this.exchangeGoodsList = guideCommodityInfo.exchangeGoodsList;
        //   this.rewardGuidingRules = guideCommodityInfo.rewardGuidingRules;
        // }

        // 获取页面模块配置信息 & 电商返佣banner信息
        const [pageModuleResult, rakeBackBannerResult] = await Promise.all([
          getPreFetchData({ preFetchName: 'getPageModulePromise' }),
          getPreFetchData({ preFetchName: 'getRakeBackBannerPromise' }),
        ]);

        // 处理电商返佣banner信息
        if (rakeBackBannerResult.result) {
          const { result, isPreFetch } = rakeBackBannerResult;
          this.rakeBackModuleInfo = {
            ...rakeBackBannerAdapter(result),
            showPopup: true,
          };
          this.setPreFetchStatus({ rakeBackBanner: isPreFetch });

          if (!isPreFetch) {
            // 预加载页面头部背景图片
            preloadImages(TOP_HEADER_BG_IMGS);
          }
        }

        // 处理页面模块配置信息
        if (pageModuleResult.result) {
          const { result, isPreFetch } = pageModuleResult;
          const { moduleList = [] } = result.data || {};
          this.moduleList = moduleList;
          this.handleModuleList({ isPreFetch: true });
          this.setPreFetchStatus({ pageModule: isPreFetch });
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('preRender => error', safeJsonStringify(error));
      }
    },
    // 初始化页面数据
    async initPageData(options) {
      const { isRefresh = false } = options || {};
      if (!this.isPureVersion) {
        // 获取奖励金&弹窗信息
        await Promise.all([
          this.refreshBounty(),
          isRefresh ? this.getRewardCountAndAb() : null,
          this.getPopupWindow({ type: 'init' }),
        ]);
      } else {
        // 获取奖励金信息
        this.refreshBounty();
      }

      // 处理页面模块配置
      this.handlePageModule({ isRefresh });
      // 处理页面回退教育弹窗逻辑
      this.handleBackGuides();
      // 页面进入曝光
      this.handlePageView();
    },
    // 初始化用户信息
    async initUser() {
      const result = await getTokenAndKey();
      const { token } = result || {};
      this.isLogin = !!token;
      this.token = token;

      return { token, isLogin: !!token };
    },
    // 处理页面模块
    async handlePageModule(options) {
      const { isRefresh = false } = options || {};
      try {
        // 获取页面模块配置
        if (!this.preFetchStatus.pageModule) {
          const { moduleList } = await getPageModuleList({
            token: this.token,
            pageType: this.isPureVersion ? 14 : 26,
          });
          if (moduleList.length === 0) return;
          this.moduleList = moduleList;
        }
        // 处理页面模块配置
        this.handleModuleList({ isPreFetch: false, isRefresh });

        // 触发组件start调用
        this.$nextTick(() => {
          // 更新页面状态为成功
          this.pageStatus = 'SUCCESS';
          setTimeout(() => {
            this.scrollAnchor();
          }, 500);
        });
      } catch (error) {
        this.pageStatus = 'SUCCESS';
        // eslint-disable-next-line no-console
        console.error('handlePageModule => error', safeJsonStringify(error));
      }
    },
    // 处理页面模块配置
    async handleModuleList(options) {
      const { isPreFetch = false, isRefresh = false } = options || {};
      if (this.moduleList.length === 0) return;

      const processedModules = this.moduleList
        .map((m) => {
          if (!isRefresh) {
            // 预取场景下，延迟处理的模块不处理
            if (isPreFetch && DEFERRED_MODULES.includes(m.moduleKey)) {
              return null;
            }
            // 非预取场景下，如果模块已存在，则不重复处理
            if (!isPreFetch && this.processedModuleKeys.includes(m.moduleKey)) {
              return null;
            }
          }

          // 处理商品兑换tab信息
          if (
            m.moduleKey === FULI_MODULE.welfare_bountyExchange
            && m.moduleData
          ) {
            this.tabs = tryCatch(() => m.moduleData[0].data, []);
          }
          // 提取公告数据并过滤掉该模块
          if (m.moduleKey === FULI_MODULE.welfare_notice) {
            const { noticeBoard, jumpUrl: noticeJumpUrl } = (m.moduleData || [])[0] || {};
            this.noticeData = { noticeBoard, jumpUrl: noticeJumpUrl };
            return false;
          }
          // 处理电商返佣额外信息
          if (m.moduleKey === FULI_MODULE.welfare_rake_back) {
            this.handleRakeBackExtInfo();
          }
          // 处理新人推荐兑换商品列表
          if (m.moduleKey === FULI_MODULE.welfare_guide_commodity) {
            const moduleData = m.moduleData || [];
            const { data } = moduleData[0] || {};
            this.handleExchangeGoodsOfNew(data || {});
          }
          if (m.moduleKey === FULI_MODULE.welfare_new_task) {
            return false;
          }
          if (
            m.moduleKey === FULI_MODULE.welfare_advertisement_video
            && this.taskScene === WELFARE_VERSION.NEW_TASK_SCENE
          ) {
            return false;
          }
          if (
            m.moduleKey === FULI_MODULE.welfare_attendance_new
            && this.taskScene === WELFARE_VERSION.NEW_TASK_SCENE
          ) {
            return FULI_MODULE.welfare_attendance;
          }
          return m.moduleKey;
        })
        .filter(Boolean); // 过滤掉 null 值

      // 更新已处理模块key列表
      this.processedModuleKeys = [
        ...this.processedModuleKeys,
        ...processedModules,
      ];

      if (isPreFetch || isRefresh) {
        this.modules = processedModules;
      } else {
        const existingModules = [...this.modules, ...processedModules];
        const allModuleKeys = this.moduleList.map((m) => {
          // 处理特殊转换逻辑
          if (
            m.moduleKey === FULI_MODULE.welfare_attendance_new
            && this.taskScene === WELFARE_VERSION.NEW_TASK_SCENE
          ) {
            return FULI_MODULE.welfare_attendance;
          }
          return m.moduleKey;
        });
        this.modules = allModuleKeys.filter((key) => existingModules.includes(key));
      }
    },
    // 页面可见性变化
    handleVisibilityChange() {
      if (document.visibilityState === 'visible') {
        // 重置预取状态
        this.setPreFetchStatus({
          rakeBackBanner: false,
          pageModule: false,
        });
        this.initPageData({ isRefresh: true });
        // 检查是否有锚定标记（从明细页返回时触发）
        const needAnchor = localStorage.getItem('welfare_need_anchor');
        if (needAnchor) {
          localStorage.removeItem('welfare_need_anchor');
          this.$nextTick(() => {
            setTimeout(() => {
              eventBus.$emit('earnPointsAnchor');
            }, 500);
          });
        }
      }
    },
    // 跳转奖励金记录页面
    goBountyRecord() {
      SPM.clickButton({
        buttonName: 'my_bonus_new',
        businessInfo: {},
      });
      jumpUrl(
        `https://m.hellobike.com/AppPlatformH5/${
          config.env !== 'pro' ? `${config.env}/` : ''
        }latest/index.html#/bounty/exchange?adsource=1&isWelfareApp=true`,
      );
    },
    // 处理页面滚动锚定
    scrollAnchor() {
      const { to, anchorModule } = this.$route.query;
      let anchorEl = null;

      setTimeout(() => {
        try {
          if (to) {
            anchorEl = document.querySelector(`.${to}`);
          }
          if (anchorModule && this.firstPageView) {
            anchorEl = document.getElementById(`${anchorModule}`);
          }
          if (anchorEl) {
            const { offsetTop } = anchorEl;
            window.scrollTo({
              top: anchorModule ? offsetTop - 95 : offsetTop,
              behavior: 'smooth',
            });
          }
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error('scrollAnchor => error', safeJsonStringify(error));
        }
        this.firstPageView = false;
      }, 500);
    },
    // 获取/刷新奖励金
    async refreshBounty() {
      try {
        const result = await getBountyBasicInfo({
          token: this.token,
          pointType: 1,
        });
        const { amount = 0, points = 0 } = result.data || {};
        this.bounty = amount;
        this.points = points;
        this.bountyLoaded = true;
        // 奖励金变化时刷新新人兑换商品
        this.handleExchangeGoodsOfNew(this.goodsCateInfo || {});
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('refreshBounty => error', safeJsonStringify(error));
      }
    },
    // 处理页面曝光
    handlePageView() {
      if (this.firstPageView) {
        // 页面曝光埋点
        SPM.pageView({
          businessInfo: {
            abtest: this.isPureVersion
              ? WELFARE_VERSION.OLD_TASK_SCENE
              : this.taskScene,
            port: '0',
          },
        });
        // 奖励金信息模块曝光埋点
        SPM.moduleExpose({
          moduleId: 'my_bonus_new',
          contentId: 'my_bonus_new',
          businessInfo: {},
        });
      }
    },
    // 领取单单返奖励金
    async collectBonus() {
      try {
        SPM.clickButton({
          pageId: 'welfare_new',
          buttonName: 'platform_dandanfanlingqu',
          categoryId: 'platform',
          businessInfo: {},
        });
        const { adCode, cityCode } = await getTokenAndLocation();

        let sceneNameEns = ['platform_points'];
        if (this.rewardSceneNameEns && this.rewardSceneNameEns.length > 0) {
          sceneNameEns = this.rewardSceneNameEns;
        }

        const params = {
          token: this.token,
          sceneCode: 'D001',
          condition: {
            sceneNameEns,
            statusSet: [1],
          },
          adCode,
          cityCode,
        };
        const { code } = await collectReward(params);
        if (code !== 0) return;
        // 更新单单返状态
        this.getRewardCountAndAb();
        this.playCollectAnimate();
        // 展示单单返引导弹窗
        eventBus.$emit('showAwardGuidePopup');
      } catch (error) {
        Toast.show('领取失败');
        // eslint-disable-next-line no-console
        console.error('collectBonus => error', safeJsonStringify(error));
      }
    },
    // 领取奖励动画
    playCollectAnimate() {
      const audio = document.getElementById('audio');
      audio.src = 'https://m.hellobike.com/resource/gallery/833/1_DdlUufFu.wav';
      audio.play().catch(() => {});
      const lottieInstance = this.$refs.lottieComponent.instance;
      if (lottieInstance) {
        lottieInstance.goToAndStop(0, true); // 从头开始
        lottieInstance.play();
      }
      // 延时更新奖励金信息
      setTimeout(() => {
        this.refreshBounty();
        audio.src = '';
      }, 1200);
    },
    // 获取页面AB版本&单单返信息
    async getRewardCountAndAb() {
      try {
        const { result } = await getPreFetchData({
          preFetchName: 'getReceiveRewardPromise',
          requestMethod: () => getReceiveRewardCount({ token: this.token }),
        });
        const { data } = result || {};
        const {
          totalRewardValue = 0, // 单单返待领取奖励金总和
          isDueSoon = false, // 待领取单单返是否即将到期
          rewardGuidingRulesList = [],
          bonusWithdrawalScene = BONUS_WITHDRAWAL_SCENE.HIDE,
          sceneNameEns,
          taskScene = WELFARE_VERSION.NEW_TASK_SCENE_V2,
        } = data || {};

        // 判断页面广告支持版本
        this.judgePageAdSupportVersion();
        // 判断是否是纯净版页面
        if (taskScene === WELFARE_VERSION.OLD_TASK_SCENE) {
          this.isPureVersion = true;
          this.popupWindowKey = POPUP_WINDOW_KEY.checkin_window;
          return;
        }

        // 单单返奖励金信息
        this.rewardCount = +totalRewardValue || 0;
        this.isDueSoon = isDueSoon;
        // 新人兑换引导规则
        this.rewardGuidingRules = getRewardGuideRules(rewardGuidingRulesList);
        // 提现入口展示实验
        this.bonusWithdrawalScene = bonusWithdrawalScene;
        // 奖励金领取场景
        this.rewardSceneNameEns = sceneNameEns;

        // 提现入口曝光埋点
        if (bonusWithdrawalScene === BONUS_WITHDRAWAL_SCENE.SHOW) {
          SPM.moduleExpose({
            pageId: 'welfare_new',
            categoryId: 'platform',
            moduleId: 'platform_tixianrukou',
            contentId: 'platform_tixianrukou',
            exposureTimes: 1,
            businessInfo: {},
          });
        }

        if (this.newTaskScene && +totalRewardValue) {
          SPM.moduleExpose({
            pageId: 'welfare_new',
            categoryId: 'platform',
            moduleId: 'platform_dandanfanlingqu',
            contentId: 'platform_dandanfanlingqu',
            exposureTimes: 1,
            businessInfo: {},
          });
        }
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error('getRewardCountAndAb => error', safeJsonStringify(err));
      }
    },
    // 获取弹窗信息
    async getPopupWindow(options) {
      const { type = 'init' } = options;
      if (type === 'init' && !this.firstPageView) return;

      const { adsource = '' } = this.$route.query;
      try {
        const result = await getPopupWindow({
          token: this.token,
          adsource,
          welfareNewVersion: false,
        });
        const { data } = result || {};
        if (data && data.length > 0) {
          const { popupWindowKey, popupWindowData = {} } = data[0] || {};
          this.popupWindowKey = popupWindowKey || POPUP_WINDOW_KEY.checkin_window;
          this.popupWindowData = popupWindowData;

          // 处理弹窗信息
          this.handlePopupWindow(popupWindowKey, popupWindowData);

          // 弹窗下发统计埋点
          SPM.customEventWithPointId({
            pointId: 'triggerExpose_popupWindow',
            businessInfo: {
              popupKey: popupWindowKey,
            },
          });
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('getPopupWindow => error', safeJsonStringify(error));
      }
    },
    // 处理弹窗信息
    handlePopupWindow(key, data) {
      switch (key) {
        // 唤端承接弹窗
        case POPUP_WINDOW_KEY.market_window:
          this.handleMarketWindow(data);
          break;
        default:
          this.popupWindow = { key, show: true, data };
          break;
      }
    },
    // 处理唤端承接弹窗
    handleMarketWindow(data) {
      const mapper = (info) => {
        const {
          activityCode = '',
          hasReceived = false,
          prizeList = [],
          ...other
        } = info;

        return {
          code: activityCode,
          status: hasReceived
            ? COUPON_STATUS.HAS_RECEIVED
            : COUPON_STATUS.NOT_RECEIVED,
          prizes: prizeList.map(
            ({ rideCard = {}, coupon = {}, ...rest }) => ({
              ...rest,
              ...rideCard,
              ...coupon,
            }),
          ),
          ...other,
        };
      };
      this.popupWindow = {
        key: POPUP_WINDOW_KEY.market_window,
        show: true,
        data: mapper(data),
      };
      // 唤端承接弹窗曝光
      SPM.moduleExpose({
        moduleId: 'Welfare_huanduanpop',
        contentId: 'Welfare_huanduanpop',
        businessInfo: {},
      });
    },
    // 处理新人兑换商品
    async handleExchangeGoodsOfNew(data) {
      if (!data.type) return;

      // 获取新人兑换商品列表
      const exchangeGoodsList = await getExchangeGoodsList(data);
      this.goodsCateInfo = { ...data, loaded: true, showPopup: true };
      if (exchangeGoodsList.length === 0) return;
      this.exchangeGoodsList = exchangeGoodsList;

      // 缓存推荐商品兑换模块信息
      const guideCommodityInfo = {
        exchangeGoodsList,
        goodsCateInfo: this.goodsCateInfo,
        rewardGuidingRules: this.rewardGuidingRules,
      };
      this.cacheModuleInfo(
        FULI_MODULE.welfare_guide_commodity,
        guideCommodityInfo,
      );
    },
    // 去提现页面
    goCashWithdraw() {
      jumpUrl(
        `https://m.hellobike.com/AppPlatformH5/${
          config.env !== 'pro' ? `${config.env}/` : ''
        }latest/index.html#/welfare/withdraw`,
      );
      // 提现入口点击埋点
      SPM.clickButton({
        pageId: 'welfare_new',
        buttonName: 'platform_tixianrukou',
        categoryId: 'platform',
        businessInfo: {},
      });
    },
    // 处理电商返佣额外信息
    async handleRakeBackExtInfo() {
      // 如果电商返佣banner预取成功，则直接使用预取数据
      if (this.preFetchStatus.rakeBackBanner) {
        return;
      }

      // 获取电商返佣banner信息
      const { success, result } = await getRakeBackBanner();
      if (!success) return;

      // 处理电商返佣banner信息
      this.rakeBackModuleInfo = {
        ...rakeBackBannerAdapter(result),
        showPopup: true,
      };
    },
    // 展示复访弹窗
    showRevisitGuide() {
      // 关闭首屏弹窗
      this.handlePopupWindowClose();
      this.revisitGuideVisible = true;
    },
    // 关闭复访弹窗
    handleRevisitGuideClose() {
      this.revisitGuideVisible = false;
      // 直接关闭当前webview
      Native.closeWebView();
    },
    // 处理页面回退教育弹窗逻辑
    async handleBackGuides() {
      if (env.isEasyBikeApp && this.isFirstLoad && !this.isPureVersion) {
        // 判断是非需要展示复访弹窗
        const needRevisitGuide = await judgeRevisitGuideVisible();
        this.needRevisitGuide = needRevisitGuide;
        if (!needRevisitGuide) return;

        // push一个相同页面，用于监听页面回退
        window.history.pushState(null, '提示弹窗', document.URL);
        // 页面回退监听
        window.addEventListener('popstate', this.showRevisitGuide, false);
      }

      this.isFirstLoad = false;
    },
    // 处理首屏弹窗关闭
    handlePopupWindowClose() {
      this.popupWindow = { key: '', show: false, data: {} };
    },
    // 设置数据预取成功状态
    setPreFetchStatus(state = {}) {
      this.preFetchStatus = {
        ...this.preFetchStatus,
        ...state,
      };
    },
    // 缓存模块信息
    cacheModuleInfo(key, data) {
      if (this.cacheOverflow) return;
      // 设置缓存
      const setSuceess = setStorageExpiresHour(key, data);
      // 缓存溢出
      this.cacheOverflow = !setSuceess;
    },
    // 判断页面广告支持版本
    async judgePageAdSupportVersion() {
      try {
        const version = await getVersion();
        const isSupport = compareVersions(version, '6.88.5') !== -1;
        if (!isSupport) {
          this.taskScene = WELFARE_VERSION.NEW_TASK_SCENE;
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('judgePageAdSupportVersion => error', safeJsonStringify(error));
      }
    },
  },
};
</script>

<style lang="less" scoped>
.fuli-container {
  overflow-x: hidden;
  padding-bottom: calc(constant(safe-area-inset-bottom) + 0.12rem);
  padding-bottom: calc(env(safe-area-inset-bottom) + 0.12rem);
  width: 100%;
  min-height: 100vh;
  background-color: #f0f3f5;

  .page-modules {
    background-color: #f0f3f5;
    border-radius: 0.16rem 0.16rem 0 0;

    .modules-new-header {
      margin-bottom: -0.54rem;
      height: 0.62rem;
      background-image: linear-gradient(180deg, #d0e3ff 0%, #f0f3f5 39.02%);
      border-top: 0.01rem solid #fff;
      border-radius: 0.16rem 0.16rem 0 0;

      &.pure-version {
        margin-bottom: -0.62rem;
      }
    }

    .fuli-module {
      border-radius: 0.12rem;
      margin: 0 0.12rem;
      margin-bottom: 0.08rem;
    }

    .exchange-style {
      width: 100%;
      margin: 0 auto;
      border-radius: 0.16rem 0.16rem 0 0;
    }
  }

  .collect-points-lottie {
    position: fixed;
    z-index: 100;
    top: calc(0.5rem + var(--welfare-notice-height, 0rem));
    left: 0;
    width: 100%;
    pointer-events: none;
  }
}

/* 全局锚定高亮样式 */
/deep/ .shine-light-animation {
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    z-index: 9;
    border: 0.02rem solid #fa4614;
    border-radius: 0.12rem;
    animation: blink-border 1.5s infinite;
  }

  &::after {
    content: '';
    z-index: 9;
    position: absolute;
    display: inline-block;
    left: 0;
    top: 0;
    width: 1rem;
    height: 100%;
    opacity: 0.9;
    transform: skewX(150deg);
    background: linear-gradient(90deg, transparent, #fff 30%, transparent);
    animation: move-light 1.1s infinite;
  }

  @keyframes move-light {
    100% {
      left: 125%;
    }
  }

  @keyframes blink-border {
    0%,
    100% {
      border-color: #fa4614;
    }

    50% {
      border-color: rgba(250, 70, 20, 30%);
    }
  }
}
</style>
